module.exports = __webpack_public_path__ + "static/media/Our-Mountain_v003.f7ee4906.mp3";